/**
 * Lesson library: keyword search, tag filters, any/all matching, sorting,
 * removable pills, and five-row pagination.
 */
export default function curriculumTable() {
    var table = document.querySelector('.ltable');
    if (!table) { return; }

    var rows = Array.prototype.slice.call(table.querySelectorAll('.lrow'));
    var chips = Array.prototype.slice.call(document.querySelectorAll('.tagchip'));
    var search = document.getElementById('lq');
    var shown = document.getElementById('lshown');
    var empty = table.querySelector('.lempty');
    var sortSelect = document.getElementById('lsortsel');
    var applied = document.getElementById('lapplied');
    var pills = document.getElementById('lappills');
    var matchButtons = Array.prototype.slice.call(document.querySelectorAll('[data-match]'));
    var pager = document.getElementById('lpager');
    var pageNums = document.getElementById('lpgnums');
    var pagePrev = document.getElementById('lpgprev');
    var pageNext = document.getElementById('lpgnext');
    var PAGE = 5;

    if (!search || !shown || !empty || !sortSelect) { return; }

    rows.forEach(function (row, index) {
        row.dataset.ord = index;
    });

    var state = { tags: [], match: 'any', sort: 'code', page: 1 };

    function matches(row) {
        var term = (search.value || '').trim().toLowerCase();
        if (term && row.textContent.toLowerCase().indexOf(term) === -1) { return false; }
        if (state.tags.length) {
            var tags = (row.dataset.tags || '').split('|');
            var hits = state.tags.filter(function (tag) {
                return tags.indexOf(tag) !== -1;
            }).length;
            if (state.match === 'all' ? hits < state.tags.length : hits === 0) { return false; }
        }
        return true;
    }

    function order(a, b) {
        switch (state.sort) {
            case 'title':
                return a.dataset.title.localeCompare(b.dataset.title);
            case 'titled':
                return b.dataset.title.localeCompare(a.dataset.title);
            case 'ngss':
                return (+b.dataset.ngss - +a.dataset.ngss) || (+a.dataset.ord - +b.dataset.ord);
            default:
                return +a.dataset.ord - +b.dataset.ord;
        }
    }

    function chip(label, onClear) {
        var button = document.createElement('button');
        button.className = 'lappill';
        button.appendChild(document.createTextNode(label));
        var mark = document.createElement('i');
        mark.setAttribute('aria-hidden', 'true');
        mark.textContent = '×';
        button.appendChild(mark);
        button.setAttribute('aria-label', 'Remove filter: ' + label);
        button.addEventListener('click', function () {
            onClear();
            refilter();
        });
        return button;
    }

    function drawApplied() {
        if (!pills || !applied) { return; }
        pills.textContent = '';
        state.tags.forEach(function (tag) {
            pills.appendChild(
                chip(tag, function () {
                    state.tags = state.tags.filter(function (item) {
                        return item !== tag;
                    });
                })
            );
        });
        if ((search.value || '').trim()) {
            pills.appendChild(
                chip('“' + search.value.trim() + '”', function () {
                    search.value = '';
                })
            );
        }
        applied.hidden = !pills.children.length;
    }

    function sync() {
        chips.forEach(function (chipEl) {
            chipEl.setAttribute('aria-pressed', state.tags.indexOf(chipEl.dataset.tag) !== -1 ? 'true' : 'false');
        });
        matchButtons.forEach(function (button) {
            button.setAttribute('aria-pressed', button.dataset.match === state.match ? 'true' : 'false');
        });
        var matchRow = document.querySelector('.lmatch');
        if (matchRow) { matchRow.hidden = state.tags.length < 2; }
    }

    function pageBtn(label, page, current) {
        var button = document.createElement('button');
        button.className = 'pgnum';
        button.type = 'button';
        button.textContent = String(label);
        if (current) { button.setAttribute('aria-current', 'page'); }
        button.setAttribute('aria-label', 'Page ' + page);
        button.addEventListener('click', function () {
            goTo(page);
        });
        return button;
    }

    function drawPager(total) {
        if (!pager || !pageNums) { return; }
        pageNums.textContent = '';
        pager.hidden = total < 2;
        if (total < 2) { return; }
        for (var page = 1; page <= total; page++) {
            pageNums.appendChild(pageBtn(page, page, page === state.page));
        }
        if (pagePrev) { pagePrev.disabled = state.page === 1; }
        if (pageNext) { pageNext.disabled = state.page === total; }
    }

    function apply() {
        var ordered = rows.slice().sort(order);
        ordered.forEach(function (row) {
            table.insertBefore(row, empty);
        });
        var hits = ordered.filter(matches);
        var total = Math.max(1, Math.ceil(hits.length / PAGE));
        if (state.page > total) { state.page = total; }
        var from = (state.page - 1) * PAGE;
        var windowSet = {};
        hits.slice(from, from + PAGE).forEach(function (row) {
            windowSet[row.dataset.ord] = true;
        });
        ordered.forEach(function (row) {
            row.hidden = !windowSet[row.dataset.ord];
        });
        shown.textContent = hits.length;
        empty.hidden = hits.length > 0;
        drawPager(total);
        drawApplied();
    }

    function goTo(page) {
        state.page = page;
        apply();
        var top = table.getBoundingClientRect().top + window.scrollY - 110;
        window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function refilter() {
        state.page = 1;
        sync();
        apply();
    }

    chips.forEach(function (chipEl) {
        chipEl.addEventListener('click', function () {
            var tag = chipEl.dataset.tag;
            var index = state.tags.indexOf(tag);
            if (index === -1) { state.tags.push(tag); }
            else { state.tags.splice(index, 1); }
            refilter();
        });
    });
    matchButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            state.match = button.dataset.match;
            refilter();
        });
    });
    sortSelect.addEventListener('change', function () {
        state.sort = sortSelect.value;
        refilter();
    });
    search.addEventListener('input', refilter);
    if (pagePrev) {
        pagePrev.addEventListener('click', function () {
            if (state.page > 1) { goTo(state.page - 1); }
        });
    }
    if (pageNext) {
        pageNext.addEventListener('click', function () {
            goTo(state.page + 1);
        });
    }

    function clearAll() {
        state.tags = [];
        state.match = 'any';
        search.value = '';
        sortSelect.value = 'code';
        state.sort = 'code';
        refilter();
    }

    var clearAllBtn = document.getElementById('lclearall');
    if (clearAllBtn) { clearAllBtn.addEventListener('click', clearAll); }
    var reset = table.querySelector('.lreset');
    if (reset) { reset.addEventListener('click', clearAll); }

    sync();
    apply();
}
